import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RestAPIEndpoints } from '@lifeomic/react-client';

type BedrockModel =
  RestAPIEndpoints['GET /v1/agents-v2/models']['Response']['models'][number];

const messages = defineMessages({
  label: {
    id: 'ModelSelect.label',
    defaultMessage: 'Model (optional)',
  },
  default: {
    id: 'ModelSelect.default',
    defaultMessage: 'Default Model',
  },
});

type ModelSelectProps = {
  modelId?: string;
  setModelId: (modelId?: string) => void;
  hideLabel?: boolean;
  models: BedrockModel[];
};

export const ModelSelect: React.FC<ModelSelectProps> = ({
  modelId,
  setModelId,
  models,
  hideLabel = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Select
      label={hideLabel ? '' : formatMessage(messages.label)}
      aria-label={hideLabel ? formatMessage(messages.label) : undefined}
      value={modelId ?? ''}
      onChange={value => setModelId(value || undefined)}
      fullWidth
    >
      <SelectOption value="" title={formatMessage(messages.default)} />
      {models.map(model => (
        <SelectOption
          key={model.model_id}
          value={model.model_id}
          title={model.model_label}
        />
      ))}
    </Select>
  );
};
